<template>
  <div class="arvore-produtos-component">
    <v-container class="fill-height" fluid>
      <v-row no-gutters class="fill-height d-flex align-center justify-center">
        <mf-toggle v-model="selectionMode" label="Modo de seleção" class="ma-0" hide-details />

        <v-spacer />
        <mf-toggle v-model="showEmptyCategories" label="Exibir categorias sem produtos" class="ma-0 pr-3" hide-details />
        <mf-button text class="mr-0" :disabled="isDialogButtonDisabled" label="Ver produtos selecionados" @click="openSelectedItemsDialog" />
      </v-row>
    </v-container>
    <arvore-produtos-selected-items v-model="dialog" :items="pickedProducts" @remove-product="removeProduct" />

    <mf-loading loader="products-tree" loader-type="dialog">
      <div class="main-tree-content">
        <v-card elevation="0">
          <v-card-text class="pa-0">
            <v-layout class="list-container">
              <v-flex v-for="level in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]" :key="level">
                <div v-if="selectedPerLevel[level] !== undefined" class="pa-2">
                  <span class="level-text pr-1">Nível {{ level + 1 }}</span>
                  <span>({{ selectedPerLevel[level].children.length | localeString }} itens)</span>
                </div>
                <div v-if="selectedPerLevel[level] !== undefined" class="list-column">
                  <dynamic-scroller
                    v-if="selectedPerLevel[level].children"
                    v-slot="{ item, index, active }"
                    class="vue-recycle-scroller scroller ready direction-vertical"
                    page-mode
                    :items="selectedPerLevel[level].children"
                    :min-item-size="56"
                  >
                    <div class="item-list">
                      <dynamic-scroller-item :item="item" :active="active" :data-index="index" watchData>
                        <arvore-produtos-list-level
                          v-if="forceUpdateItens"
                          :item.sync="item"
                          :selection-mode="selectionMode"
                          :picked-products="pickedProducts"
                          :on-path="isItemOnPath(selectedPerLevel[level + 1], item)"
                          @selected-item="selectedItem"
                          @picked-item="pickedItem"
                        />
                      </dynamic-scroller-item>
                    </div>
                  </dynamic-scroller>
                  <!-- </div> -->
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </div>
    </mf-loading>
  </div>
</template>

<script>
import ArvoreProdutosListLevel from '@/components/ArvoreProdutosListLevel.vue'
import ArvoreProdutosSelectedItems from '@/components/ArvoreProdutosSelectedItems.vue'
import { mapWaitingActions } from 'vue-wait'
import { mapState } from 'vuex'
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

export default {
  components: {
    ArvoreProdutosListLevel,
    ArvoreProdutosSelectedItems,
    DynamicScroller,
    DynamicScrollerItem,
  },
  data: () => ({
    selectedPerLevel: [],
    selectionMode: false,
    showEmptyCategories: false,
    pickedProducts: [],
    dialog: false,
    forceUpdateCounter: 0,
    forceUpdateItens: true,
  }),
  computed: {
    ...mapState({
      stateProductsTree: (state) => state.produtos.productsTree,
    }),
    isDialogButtonDisabled() {
      if (!this.selectedPerLevel.length) return true
      const pickedOrIndeterminate = this.selectedPerLevel[0].children.filter((obj) => obj.indeterminate || obj.picked).length
      return Boolean(pickedOrIndeterminate === 0)
    },
  },
  watch: {
    async showEmptyCategories() {
      await this.getData()
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapWaitingActions({
      productsTree: 'products-tree',
    }),
    selectedItem(item) {
      if (item.children && item.children.length) {
        this.selectedPerLevel = this.selectedPerLevel.slice(0, item.level).concat(item)
        this.$nextTick(() => {
          let container = document.querySelector('.list-container')
          container.scrollLeft = container.scrollWidth
        })
      } else {
        this.selectedPerLevel = this.selectedPerLevel.slice(0, item.level)
      }
    },
    pickAllChildren(parent) {
      if (parent.children === undefined) return
      parent.children.forEach((eachItem) => {
        eachItem.picked = parent.picked
        eachItem.indeterminate = parent.indeterminate
        this.pickAllChildren(eachItem)
      })
    },
    pickedItem(item, value) {
      this.forceUpdateItens = false
      this.selectedItem(item)
      this.updateParentPickedStatus(item)
      this.pickAllChildren(item)
      this.$nextTick(() => {
        this.forceUpdateItens = true
      })
    },
    updateParentPickedStatus(item) {
      if (!item.level) return

      for (let parentLevel = item.level - 1; parentLevel >= 1; parentLevel--) {
        const parentObject = this.selectedPerLevel[parentLevel]

        if (parentObject) {
          let indeterminateChildren = parentObject.children.filter((obj) => obj.indeterminate).length
          let pickedChildren = parentObject.children.filter((obj) => obj.picked).length

          let childrenLength = parentObject.children.length
          if (indeterminateChildren >= 1) {
            this.setCheckboxToIndeterminate(parentObject)
          } else if (pickedChildren === 0) {
            this.setCheckboxToFalse(parentObject)
          } else if (childrenLength === pickedChildren) {
            this.setCheckboxToTrue(parentObject)
          } else {
            this.setCheckboxToIndeterminate(parentObject)
          }
        }
      }
    },
    setCheckboxToFalse(object) {
      object.picked = false
      object.indeterminate = false
    },
    setCheckboxToIndeterminate(object) {
      object.picked = false
      object.indeterminate = true
    },
    setCheckboxToTrue(object) {
      object.picked = true
      object.indeterminate = false
    },
    isItemOnPath(selected, item) {
      if (!selected || !item) return false
      return Boolean(selected.name === item.name)
    },
    updatePickedProducts(parent, path = []) {
      if (parent.children === undefined) return
      if (parent.children[0] !== undefined && parent.children[0].level === 1) {
        this.pickedProducts = []
      }
      parent.children.forEach((eachItem) => {
        if (eachItem.picked && eachItem.isProduct) {
          this.pickedProducts.push({
            ...eachItem,
            categoriesPath: path
              .concat([parent])
              .filter((category) => category.name)
              .map((category) => ({
                id: category.id,
                name: category.name,
              })),
          })
        }
        this.updatePickedProducts(eachItem, [...path, parent])
      })
    },
    getData() {
      this.productsTree({ should_trim_tree: !this.showEmptyCategories }).then(() => {
        this.selectedPerLevel = [this.stateProductsTree]
      })
    },
    openSelectedItemsDialog() {
      this.updatePickedProducts(this.stateProductsTree)
      this.dialog = true
    },
    removeProduct({ item, index }) {
      this.forceUpdateItens = false

      item.picked = false
      this.updateParentPickedStatus(item)

      this.pickedProducts.splice(index, 1)
      // Isso vai fazer com que a computed 'isDialogButtonDisabled' seja atualizada
      this.forceUpdateCounter++

      this.$nextTick(() => {
        this.forceUpdateItens = true
      })
    },
  },
}
</script>
<style lang="scss">
.main-tree-content {
  > .v-card {
    height: calc(100vh - 250px);
    > .v-card__text {
      height: 100%;
      border-radius: 0;
    }
    .list-container {
      scroll-behavior: smooth;
      overflow-x: auto;
      border-radius: 0;
      height: 100%;
      > .flex {
        width: 250px;
        max-width: 250px;
      }
      .level-text {
        color: $cinza-d20;
        font-size: 18px;
      }
      .list-column {
        width: 250px;
        overflow-y: auto;
        max-height: calc(100% - 43px);
      }
    }
  }
  .scroller {
    height: 100%;
  }

  .item-list {
    display: flex;
    height: 45%;
  }
}
</style>
